import { type ListViewTypeRestrictionType } from '../Behaviors.types';
import { assertNever } from 'owa-assert';
import type ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { getSafeSelectedTableView } from 'owa-mail-list-store';
import { isReadingPaneStackedView } from 'owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils';

export const listViewTypeRestrictionType =
    (restrictionType: ListViewTypeRestrictionType) => (): boolean => {
        const tableView = getSafeSelectedTableView();
        const listViewType = tableView?.tableQuery?.listViewType;
        switch (restrictionType) {
            case 2:
                return listViewType === 1 || !isReadingPaneStackedView(listViewType);

            case 1:
                return isReadingPaneStackedView(listViewType);

            default:
                throw assertNever(restrictionType);
        }
    };
